<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.property.selected_property' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
<ul role="list" class="divide-y divide-gray-200 overflow-y-auto zuper-scrollbar data-picker-list-content-height"
    *ngIf="properties.length">
    <li class="property-data-picker-list-ele" *ngFor="let property of properties;let index = index">
        <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5 w-full"
            [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
            (click)="selectOption === 'readOnly' ? viewPropertyDetails($event, property.property_uid) : null">
            <a class="-m-1 block flex-1 p-1 picker-data-parent-container">
                <div class="relative flex min-w-0 flex-1 items-center">
                    <div class="picker-data-inner-container flex" *ngIf="selectOption === 'multiSelect'">
                        <span class="flex items-center flex justify-center px-1">
                            <input type="checkbox" class="picker-data-selection-size" id="property_data_select_{{index}}"
                                (change)="selectProperty($event, property)" [checked]="isSelectedProperty(property)"
                                [disabled]="validateSelectionDisable(property)" [matTooltip]="getDisableMessage(property)" />
                        </span>
                        <div class="ml-4 truncate picker-data-value-content">
                            <ng-container *ngTemplateOutlet="propertiesContent"></ng-container>
                        </div>
                    </div>
                    <div class="picker-data-inner-container flex" *ngIf="selectOption === 'select'">
                        <span class="flex items-center flex justify-center px-1">
                            <input type="radio" class="picker-data-selection-size" id="property_data_select_{{index}}"
                                (change)="selectProperty($event, property)" [checked]="isSelectedProperty(property)"
                                [disabled]="validateSelectionDisable(property)" [matTooltip]="getDisableMessage(property)" />
                        </span>
                        <div class="ml-4 truncate picker-data-value-content">
                            <ng-container *ngTemplateOutlet="propertiesContent"></ng-container>
                        </div>
                    </div>
                    <ng-container *ngIf="selectOption === 'readOnly'">
                        <div class="ml-2 truncate picker-data-value-content">
                            <ng-container *ngTemplateOutlet="propertiesContent"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #propertiesContent>
                        <div class="w-full flex flex-col">
                            <label class="truncate text-lg font-medium text-gray-900 cursor-pointer" for="property_data_select_{{index}}">
                                {{property.property_name}}
                            </label>
                        </div>
                    </ng-template>
                    <button mat-icon-button class="cursor-pointer ml-auto"
                        matTooltip="{{ updateArrowTooltipText(property.property_uid) | translate }}" matTooltipPosition="left"
                        *ngIf="!showSpinLoading(property.property_uid)" [ngClass]="rotateArrowIcon(property.property_uid)"
                        (click)="viewPropertyDetails($event, property.property_uid)">
                        <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                            data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down" width="24"
                                height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                </path>
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </mat-icon>
                    </button>
                    <div class="ml-auto py-2.5 h-10" *ngIf="showSpinLoading(property.property_uid)">
                        <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px">
                        </mat-spinner>
                    </div>
                </div>
            </a>
        </div>
        <div class="p-4 bg-gray-100"
            *ngIf="('property_details_' + property.property_uid === propertyEleId) && propertyDetails && !isSpinLoading">
            <div class="bg-card rounded relative">
                <a target="_blank" class="hidden" #propViewFullDetails
                    href="{{viewPropertyFullDetails(property.property_uid)}}"></a>
                <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="propViewFullDetails.click($event)"
                    matTooltip="{{'text.view_details.new_tab' | translate}}"
                    matTooltipPosition="left">
                    <button mat-icon-button>
                        <mat-icon class="text-xl">open_in_new</mat-icon>
                    </button>
                </span>
                <div class="text-base">
                    <div class="px-2 truncate flex flex-wrap">
                        <div *ngIf="propertyDetails.property_organization?.organization_name"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer property-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.organization_name' | translate}}</p>
                            <p class="mt-1 text-gray-900"
                                *ngIf="propertyDetails.property_organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                                {{propertyDetails.property_organization.organization_name}}</p>
                            <p class="mt-1">
                                <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                    [routerLink]="utilityService.getLink('ORGANIZATION', propertyDetails.property_organization.organization_uid)"
                                    *ngIf="!propertyDetails.property_organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                                    {{propertyDetails.property_organization.organization_name}}</a>
                            </p>
                        </div>
                        <div *ngIf="isValidValue(propertyDetails.no_of_jobs)"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer property-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'text.no_of_jobs' | translate}} </p>
                            <p class="mt-1 text-gray-900">
                                {{propertyDetails.no_of_jobs}}</p>
                        </div>
                        <div
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer property-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'status.text' | translate}} </p>
                            <div class="mt-2">
                                <badge [options]="getStatusBadgeOptions(propertyDetails.is_active ? 'ACTIVE' : 'INACTIVE', (propertyDetails.is_active ? 'active.text' :
                                                            'text.inactive')
                                                            |
                                                            translate)"></badge>
                            </div>
                        </div>
                        <div *ngIf="propertyDetails.created_by"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer property-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created.by.text' | translate}}</p>
                            <p class="mt-1 text-gray-900">
                                {{propertyDetails.created_by.first_name}}
                                {{propertyDetails.created_by.last_name}}</p>
                        </div>
                        <div *ngIf="propertyDetails.created_at"
                            class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer property-details-fields dark:bg-hover flex-item-wrap">
                            <p class="font-medium leading-5 truncate text-gray-500">
                                {{'created.at.text' | translate}} </p>
                            <p class="mt-1 text-gray-900">
                                {{propertyDetails.created_at | datetime}}</p>
                        </div>
                    </div>
                </div>
                <div class="py-2 border-t text-base"
                    *ngIf="propertyDetails.property_customers && propertyDetails.property_customers.length > 0">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'text.customers_associated' | translate}}
                        ({{propertyDetails.property_customers.length}})</p>
                    <div class="overflow-auto zuper-scrollbar max-h-60">
                        <ul role="list" class="divide-y divide-gray-200 px-5">
                            <li class="py-3 flex" *ngFor="let customers of propertyDetails.property_customers">
                                <div class="inline-flex overflow-hidden flex-shrink-0">
                                    <div
                                        class="flex items-center justify-center rounded-lg overflow-hidden uppercase text-3xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-12 w-12">
                                        {{customers.customer.customer_first_name[0]}}
                                    </div>
                                </div>
                                <div class="ml-3 mt-1.5 text-base cursor-default">
                                    <p class="font-medium text-gray-900 cursor-not-allowed" *ngIf="customers.customer.is_deleted">
                                        {{customers.customer.customer_first_name}}
                                        {{customers.customer.customer_last_name ?? ''}}</p>
                                    <a *ngIf="!customers.customer.is_deleted" target="_blank"
                                        class="font-medium text-gray-900 cursor-pointer hover:underline hover:text-primary-500 truncate"
                                        [routerLink]="utilityService.getLink('CUSTOMER', customers.customer.customer_uid)">
                                        {{customers.customer.customer_first_name}}
                                        {{customers.customer.customer_last_name ?? ''}}</a>
                                    <p class="text-gray-500" *ngIf="customers.customer.customer_email">
                                        <a target="_blank" href="mailto:{{customers.customer.customer_email}}">
                                            {{customers.customer.customer_email}}
                                        </a>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="px-2 py-2 border-t text-base"
                    *ngIf="propertyDetails.property_address && (propertyDetails.property_address.street || propertyDetails.property_address.state)">
                    <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                        {{'text.property_address' | translate}} </p>
                    <div class="px-3">
                        <p *ngIf="propertyDetails.property_address.street" class="text-base mb-2">
                            {{propertyDetails.property_address.street}}</p>
                        <p *ngIf="propertyDetails.property_address.landmark" class="text-base mb-2">
                            {{propertyDetails.property_address.landmark}}</p>
                        <p *ngIf="propertyDetails.property_address.city" class="text-base mb-2">
                            {{propertyDetails.property_address.city}}</p>
                        <p *ngIf="propertyDetails.property_address.state" class="text-base mb-2">
                            {{propertyDetails.property_address.state}}
                            {{propertyDetails.property_address.zip_code ? '- ' +
                            propertyDetails.property_address.zip_code : '' }}</p>
                        <p *ngIf="propertyDetails.property_address.country" class="text-base">
                            {{propertyDetails.property_address.country}}</p>
                    </div>
                </div>
            </div>
        </div>
    </li>
</ul>
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!properties.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_organization_found.svg" alt="No Properties Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.property.not_found' |
            translate}} '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.property.placeholder' | translate}}
        </h4>
    </div>
</div>